import React, { useEffect } from "react";

import { useQuery } from "@apollo/client";

import { LOAD_WALLET } from "GraphQL/Queries";

import SelectionDetails from "./SelectionDetails";
import vaultStore from "stores/vaultStore";

import Toast from "components/toast/toast";

const Checkout = ({ close, _package }) => {
  const { updateCurrentAccount } = vaultStore;
  // Function to handle clicks inside the modal body
  const handleModalClick = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling up to the overlay
  };

  const { error, data } = useQuery(LOAD_WALLET);

  useEffect(() => {
    if (data?.me) {
      updateCurrentAccount(data.me.user.currentAccount);
    }
  }, [data?.me]);

  return (
    <div
      onClick={close} // Close modal when clicking outside the modal body
      className="z-[99999999999] pt-8 px-8 bg-black-100/50 fixed top-0 left-0 w-full h-screen flex justify-end"
    >
      <Toast />
      {/* Modal body start */}
      <div
        onClick={handleModalClick} // Prevent click from closing modal when inside the body
        className="w-full max-w-[540px] bg-white-100 rounded-lg h-[95%]"
      >
        <section className="bg-[#F5F7F9] rounded-lg mt-2 h-full">
          <SelectionDetails _package={_package} close={close} />
        </section>
      </div>
      {/* Modal body ends */}
    </div>
  );
};

export default Checkout;
